import CityPageTemplate from "../city-template/CityPageTemplate";
import { mandanConfig } from "./data";

export default function MandanPage() {
  return <CityPageTemplate config={mandanConfig} />;
}